export var getQueryParams = function getQueryParams(urlParams) {
  return new URLSearchParams(urlParams).toString();
};
export var parseQueryParams = function parseQueryParams(urlParams) {
  return new URLSearchParams(urlParams).entries();
};